<template>
  <!-- z-index below the main app bar (1004 on the server, 1006 after hydration): its shadow shows from the first paint. -->
  <v-app-bar
    class="border-b hidden-sm-and-down"
    style="top: 64px; z-index: 1003;"
    flat
  >
    <tabs-menu :menu="menu" />
  </v-app-bar>
  <router-view />
</template>

<script setup lang="ts">
import { getMenuTree } from '~~/shared/services/menu/MenuService';

const menu = getMenuTree('/wiresock-secure-connect');
</script>
